import React from "react";
import { CheckCircle2, Heart, MapPin, ShieldCheck } from "lucide-react";

const ABOUT_IMG =
  "https://static.prod-images.emergentagent.com/jobs/1d8d6f75-1116-44e7-832c-39bdf552935e/images/0480c777879e9d6a932fd88b0c0a368afbfbfb6148d4aa159a3989136ddd7c54.png";

const PROMISES = [
  { icon: Heart, label: "Honest, friendly service" },
  { icon: MapPin, label: "Local & area-focused" },
  { icon: CheckCircle2, label: "Tidy finish, every time" },
];

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 sm:py-32 px-6 sm:px-10 lg:px-14 bg-brand-sand-2"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-5 relative">
          <div className="relative rounded-[2rem] overflow-hidden shadow-[0_30px_60px_rgba(44,62,20,0.18)] aspect-[4/5]">
            <img
              src={ABOUT_IMG}
              alt="Hands carefully planting in soil"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute -bottom-6 -right-4 sm:-right-6 bg-brand-moss text-white rounded-3xl px-7 py-6 shadow-xl max-w-[260px]">
            <div className="font-display text-4xl font-bold leading-none">10+</div>
            <div className="text-sm mt-1 text-brand-sand/90">years getting our hands dirty for happy customers</div>
          </div>
        </div>

        <div className="lg:col-span-7">
          <span className="text-xs uppercase tracking-[0.22em] font-semibold text-brand-terracotta">
            About Rafael Costa Garden Care
          </span>
          <h2
            data-testid="about-heading"
            className="mt-3 font-display font-bold text-brand-moss-deep text-4xl sm:text-5xl lg:text-[3.4rem] leading-[1.05] tracking-tight"
          >
            We treat every garden<br />like it's our own.
          </h2>
          <p className="mt-6 text-lg text-brand-charcoal/85 leading-relaxed max-w-xl">
            Rafael Costa Garden Care is a small, family-run gardening team who genuinely love
            what we do. We turn up with a smile, listen to what you actually want, and look
            after your patch with old-school care — no rushed jobs, no cutting corners,
            just proper gardening.
          </p>

          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-3.5 max-w-xl">
            {PROMISES.map((p, i) => {
              const Icon = p.icon;
              return (
                <div
                  key={i}
                  data-testid={`promise-${i}`}
                  className="flex items-center gap-3 bg-white rounded-2xl px-5 py-4 border border-brand-line"
                >
                  <span className="grid place-items-center w-9 h-9 rounded-full bg-brand-moss/10 text-brand-moss">
                    <Icon className="w-4 h-4" strokeWidth={2.2} />
                  </span>
                  <span className="text-sm font-medium text-brand-moss-deep">{p.label}</span>
                </div>
              );
            })}
          </div>

          <a
            href="/docs/insurance-certificate.pdf"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="insurance-card"
            className="mt-5 max-w-xl flex items-start sm:items-center gap-4 p-5 rounded-2xl bg-brand-moss text-white hover:bg-brand-moss-dark transition-colors group"
          >
            <span className="grid place-items-center w-11 h-11 rounded-full bg-white/15 shrink-0">
              <ShieldCheck className="w-5 h-5" strokeWidth={2.2} />
            </span>
            <div className="flex-1">
              <div className="text-[11px] uppercase tracking-[0.2em] font-semibold text-white/70">Fully Insured</div>
              <div className="font-display font-semibold text-base mt-0.5 leading-tight">
                £1m Public Liability · £10m Employer's Liability
              </div>
              <div className="text-xs text-white/70 mt-1">
                Underwritten via Simply Business · valid through July 2026
              </div>
            </div>
            <span className="text-xs font-semibold underline underline-offset-4 whitespace-nowrap opacity-90 group-hover:opacity-100">
              View certificate
            </span>
          </a>

          <div className="mt-10 p-6 rounded-3xl bg-white border border-brand-line max-w-xl">
            <p className="text-base text-brand-charcoal/90 italic leading-relaxed">
              "We started Rafael Costa Garden Care because we wanted gardening to feel personal again —
              the kind where your gardener knows your roses by name."
            </p>
            <div className="mt-3 text-sm font-semibold text-brand-moss-deep">— Rafael Costa</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
